"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationForField = validationForField;
exports.componentStylePropType = exports.benefitPlanCostType = exports.validateAck = exports.validateIsNumberOptional = exports.validateIsNumber = exports.targetAudienceRolePropType = exports.remoteEntityPropType = exports.remoteEntityAddressPropType = exports.currencyPropType = exports.requiredCurrencySchema = exports.currencySchema = exports.documentValidation = exports.invoiceFileValidation = exports.invoiceFileValidationOptional = exports.payslipFileValidation = exports.fileValidation = exports.extraIDdocsValidation = exports.fileArrayValidation = exports.requiredFileArrayValidation = exports.requiredFileValidation = exports.fileSizeValidation = exports.requiredFile = exports.daysOffSchema = exports.hoursWorkedSchema = exports.vatNumberValidation = exports.mobileNumberValidation = exports.currencyWithNegativeAmountSchema = exports.currencyAmountSchema = exports.contractStatusSchema = exports.employeePropType = exports.countryPropType = exports.requiredCountrySchema = exports.countrySchema = exports.multiSelect = exports.NinSchema = exports.integerSchema = exports.yearMonthSchema = exports.maskedInputYearMonthPlaceholder = exports.maskedInputYearMonthFormat = exports.dateSchema = exports.dateFormatterPattern = exports.maskedInputDatePlaceholder = exports.maskedInputDateFormat = exports.emailSchema = exports.contractorInvoiceNumber = exports.passwordConfirmationMessage = exports.passwordConfirmationSchema = exports.requiredPasswordSchema = exports.passwordSchema = exports.maxLengthBaseString = exports.baseString = exports.goalOptionRequiredLabel = exports.genericRequiredLabel = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _yup = require("yup");

var _constants = require("../domains/files/constants");

var _helpers = require("../domains/files/helpers");

var _constants2 = require("../domains/registration/auth/constants");

var _constants3 = require("../domains/benefits/constants");

var _currency = require("./currency");

var _statuses = require("./statuses");

var genericRequiredLabel = 'Required field';
exports.genericRequiredLabel = genericRequiredLabel;
var goalOptionRequiredLabel = 'Please select one of the options above';
exports.goalOptionRequiredLabel = goalOptionRequiredLabel;
var baseString = (0, _yup.string)().trim();
exports.baseString = baseString;
var maxLengthBaseString = baseString.max(255, function (message) {
  return "Must be at most ".concat(message.max, " characters");
});
exports.maxLengthBaseString = maxLengthBaseString;
var passwordSchema = baseString;
exports.passwordSchema = passwordSchema;
var requiredPasswordSchema = passwordSchema.required('Password is required');
exports.requiredPasswordSchema = requiredPasswordSchema;
var passwordConfirmationSchema = baseString.required(genericRequiredLabel);
exports.passwordConfirmationSchema = passwordConfirmationSchema;
var passwordConfirmationMessage = 'Confirm password must match password';
exports.passwordConfirmationMessage = passwordConfirmationMessage;
var contractorInvoiceNumber = baseString.max(10, function (message) {
  return "Please insert up to ".concat(message.max, " characters");
}).matches(/^[a-zA-Z0-9]{1,10}$/g, 'Please enter a valid number in this format: ABC1234567');
exports.contractorInvoiceNumber = contractorInvoiceNumber;
var emailSchema = baseString.email('Please enter a valid email address.');
exports.emailSchema = emailSchema;
var todayDateHint = new Date().toISOString().substring(0, 10); // get just date

/**
 *
 * @deprecated use <DatePicker>
 * Know more at: https://gitlab.com/remote-com/employ-starbase/tracker/-/issues/1918
 */

var maskedInputDateFormat = '9999-99-99';
/**
 *
 * @deprecated use <DatePicker>
 * Know more at: https://gitlab.com/remote-com/employ-starbase/tracker/-/issues/1918
 */

exports.maskedInputDateFormat = maskedInputDateFormat;
var maskedInputDatePlaceholder = 'yyyy-mm-dd';
exports.maskedInputDatePlaceholder = maskedInputDatePlaceholder;
var dateFormatterPattern = 'yyyy-MM-dd';
exports.dateFormatterPattern = dateFormatterPattern;
var dateSchema = baseString.matches(/(?:\d){4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9]|3[0-1])/, "Must be a valid date in ".concat(maskedInputDatePlaceholder, " format. e.g. ").concat(todayDateHint));
exports.dateSchema = dateSchema;
var maskedInputYearMonthFormat = '9999-99';
exports.maskedInputYearMonthFormat = maskedInputYearMonthFormat;
var maskedInputYearMonthPlaceholder = 'yyyy-mm';
exports.maskedInputYearMonthPlaceholder = maskedInputYearMonthPlaceholder;
var yearMonthSchema = baseString.matches(/(?:\d){4}-(?:0[1-9]|1[0-2])/, "Must be a valid month in ".concat(maskedInputYearMonthPlaceholder, " format. e.g. ").concat(todayDateHint.substring(0, 7)));
exports.yearMonthSchema = yearMonthSchema;
var integerSchema = (0, _yup.number)().integer("Can't have decimals");
exports.integerSchema = integerSchema;
var NinSchema = (0, _yup.string)() // Remove spaces in the number
.transform(function (value) {
  return value.replace(/ /g, '');
}).matches(/[A-CEGHJ-NOPR-TW-Z]{2}[0-9]{6}[ABCD\s]{1}/g, 'Please enter a valid NIN number in this format: AB123456C');
exports.NinSchema = NinSchema;
var multiSelect = (0, _yup.array)().of((0, _yup.object)().shape({
  label: baseString,
  value: baseString
})).typeError('Requires a set of options');
exports.multiSelect = multiSelect;
var countrySchema = (0, _yup.object)().shape({
  code: baseString,
  features: (0, _yup.array)().of(baseString),
  name: baseString,
  slug: baseString
});
exports.countrySchema = countrySchema;
var requiredCountrySchema = countrySchema.typeError('Requires a country object').test('countrySlug', "Please select a country", function validateCountry(country) {
  return !!country.slug;
});
exports.requiredCountrySchema = requiredCountrySchema;

var countryPropType = _propTypes["default"].shape({
  code: _propTypes["default"].string,
  features: _propTypes["default"].arrayOf(_propTypes["default"].string),
  name: _propTypes["default"].string,
  slug: _propTypes["default"].string
});

exports.countryPropType = countryPropType;

var employeePropType = _propTypes["default"].shape({
  name: _propTypes["default"].string,
  slug: _propTypes["default"].string
});

exports.employeePropType = employeePropType;
var contractStatusSchema = baseString.oneOf(_statuses.contractStatuses.map(function (status) {
  return status.value;
}));
exports.contractStatusSchema = contractStatusSchema;
var currencyAmountSchema = baseString.test('is-valid-currency-amount', 'Please, use US standard currency format. Ex: 1024.12', function (value) {
  return !value || (0, _currency.isValidCost)(value);
});
exports.currencyAmountSchema = currencyAmountSchema;
var currencyWithNegativeAmountSchema = baseString.test('is-valid-currency-with-negative-amount', 'Please, use US standard currency format. Ex: 1024.12', function (value) {
  return !value || (0, _currency.isValidCost)(value) || (0, _currency.isValidNegativeCost)(value);
});
exports.currencyWithNegativeAmountSchema = currencyWithNegativeAmountSchema;
var mobileNumberValidation = baseString.required(genericRequiredLabel).max(30, 'Must be at most 30 digits').matches(/^(\+|00)\d*$/, 'Please insert only the country code and phone number, without letters or spaces');
exports.mobileNumberValidation = mobileNumberValidation;
var vatNumberValidation = baseString.required(genericRequiredLabel).matches(/^\w*$/, "Please don't include spaces or dashes");
exports.vatNumberValidation = vatNumberValidation;
var hoursWorkedSchema = (0, _yup.number)().integer("Can't have decimals").min(0, 'Must be 0 or greater').required(genericRequiredLabel);
exports.hoursWorkedSchema = hoursWorkedSchema;
var daysOffSchema = (0, _yup.number)().min(0, 'Must be 0 or greater').required(genericRequiredLabel); // FILES

exports.daysOffSchema = daysOffSchema;

function generateFileValidation(formats) {
  return (0, _yup.mixed)().test('fileFormat', 'Unsupported format', function (value) {
    var _value$name;

    // this is the File object from the API and it's an edit form
    if (!value || !(value instanceof File) && (value === null || value === void 0 ? void 0 : (_value$name = value.name) === null || _value$name === void 0 ? void 0 : _value$name.length) > 0) {
      return true;
    }

    return value && formats.includes(value.type);
  });
}

var requiredFile = (0, _yup.mixed)().required('File is required');
exports.requiredFile = requiredFile;
var fileSizeValidation = (0, _yup.mixed)().test('fileSize', "File size too large. The limit is ".concat(_constants.MAX_MB_FILE_SIZE, " MB."), function (value) {
  var _value$name2;

  // this is the File object from the API and it's an edit form
  if (!value || !(value instanceof File) && (value === null || value === void 0 ? void 0 : (_value$name2 = value.name) === null || _value$name2 === void 0 ? void 0 : _value$name2.length) > 0) {
    return true;
  }

  return value && (0, _helpers.validateFileSize)(value.size, _constants.MAX_FILE_SIZE_BYTES);
});
exports.fileSizeValidation = fileSizeValidation;
var requiredFileValidation = (0, _yup.mixed)().required('File is required').test('fileSize', "File size too large. The limit is ".concat(_constants.MAX_MB_FILE_SIZE, " MB."), function (value) {
  return value && (0, _helpers.validateFileSize)(value.size, _constants.MAX_FILE_SIZE_BYTES);
});
exports.requiredFileValidation = requiredFileValidation;
var requiredFileArrayValidation = (0, _yup.array)().required('File is required').test('fileSize', "File size too large. The limit is ".concat(_constants.MAX_MB_FILE_SIZE, " MB."), function (validationFiles) {
  return (// Files pre-filled from the API have no size and are valid
    validationFiles && validationFiles.every(function (file) {
      return !file.size || (0, _helpers.validateFileSize)(file.size, _constants.MAX_FILE_SIZE_BYTES);
    })
  );
});
exports.requiredFileArrayValidation = requiredFileArrayValidation;
var fileArrayValidation = (0, _yup.array)().test('fileSize', "File size too large. The limit is ".concat(_constants.MAX_MB_FILE_SIZE, " MB."), function (validationFiles) {
  return (// Files pre-filled from the API have no size and are valid
    !validationFiles || validationFiles && validationFiles.every(function (file) {
      return !file.size || (0, _helpers.validateFileSize)(file.size, _constants.MAX_FILE_SIZE_BYTES);
    })
  );
}); // This assumes other ID cards are optional if there is the main doc ic (personalId)

exports.fileArrayValidation = fileArrayValidation;
var extraIDdocsValidation = fileArrayValidation.when('personalId', function (personalId, schema) {
  return !personalId ? schema.required('Required if no List A document.') : schema;
});
exports.extraIDdocsValidation = extraIDdocsValidation;
var fileValidation = requiredFile.concat(fileSizeValidation).concat(generateFileValidation(_constants.DEFAULT_SUPPORTED_FORMATS));
exports.fileValidation = fileValidation;
var payslipFileValidation = requiredFile.concat(fileSizeValidation).concat(generateFileValidation(_constants.PAYSLIP_SUPPORTED_FORMATS));
exports.payslipFileValidation = payslipFileValidation;
var invoiceFileValidationOptional = fileSizeValidation.concat(generateFileValidation(_constants.INVOICE_SUPPORTED_FORMATS));
exports.invoiceFileValidationOptional = invoiceFileValidationOptional;
var invoiceFileValidation = invoiceFileValidationOptional.concat(requiredFile);
exports.invoiceFileValidation = invoiceFileValidation;
var documentValidation = (0, _yup.mixed)().concat(fileSizeValidation).concat(generateFileValidation(_constants.DOCUMENT_SUPPORTED_FORMATS));
exports.documentValidation = documentValidation;
var currencySchema = (0, _yup.object)().shape({
  code: baseString,
  slug: baseString,
  symbol: baseString
});
exports.currencySchema = currencySchema;
var requiredCurrencySchema = countrySchema.typeError('Requires a currency object').test('countrySlug', "Please select a currency", function validateCurrency(currency) {
  return !!currency.code;
});
exports.requiredCurrencySchema = requiredCurrencySchema;

var currencyPropType = _propTypes["default"].shape({
  code: _propTypes["default"].string,
  slug: _propTypes["default"].string,
  symbol: _propTypes["default"].string
});

exports.currencyPropType = currencyPropType;

var remoteEntityAddressPropType = _propTypes["default"].shape({
  address: _propTypes["default"].string,
  country: countryPropType
});

exports.remoteEntityAddressPropType = remoteEntityAddressPropType;

var remoteEntityPropType = _propTypes["default"].shape({
  address: remoteEntityAddressPropType,
  slug: _propTypes["default"].string
});

exports.remoteEntityPropType = remoteEntityPropType;

var targetAudienceRolePropType = _propTypes["default"].oneOf([_constants2.userRole.EMPLOYER, _constants2.userRole.EMPLOYEE]);

exports.targetAudienceRolePropType = targetAudienceRolePropType;
var validateIsNumber = (0, _yup.number)().typeError('The value must be a number').test('is-number', 'The value must be a number', function (value) {
  return !Number.isNaN(parseFloat(value));
});
exports.validateIsNumber = validateIsNumber;
var validateIsNumberOptional = (0, _yup.number)().typeError('The value must be a number').test('is-number', 'The value must be a number', function (value) {
  return !Number.isNaN(parseFloat(value)) || value === undefined;
});
exports.validateIsNumberOptional = validateIsNumberOptional;
var validateAck = baseString.required('Please acknowledge this field');
exports.validateAck = validateAck;
var benefitPlanCostType = (0, _yup.mixed)().oneOf(Object.values(_constants3.benefitPlanCostTypes));
exports.benefitPlanCostType = benefitPlanCostType;

var componentStylePropType = _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].arrayOf(_propTypes["default"].string)]);

exports.componentStylePropType = componentStylePropType;

function validationForField(_ref) {
  var name = _ref.name,
      validate = _ref.validate,
      _visibilityCondition = _ref.visibilityCondition,
      schemaType = _ref.schemaType;
  return {
    visibilityCondition: function visibilityCondition(_ref2) {
      var existingFieldValue = _ref2[name];
      return _visibilityCondition ? _visibilityCondition(existingFieldValue) : validate(existingFieldValue);
    },
    schema: schemaType.when(name, {
      is: function is(existingFieldValue) {
        return validate(existingFieldValue);
      },
      then: schemaType.required(genericRequiredLabel),
      otherwise: schemaType
    })
  };
}